export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11941.f9592ecd.jpg";